import React, { useRef } from 'react';
import { useResearchContext } from "../../ResearchContext.provider";
import useOutsideClick from 'hooks/useOutsideClick';
import { getRelativeTimeFromEpoch } from 'utils/time.util';
import CircleLoader from 'components/CircleLoader/CircleLoader';
import './ConversationHistory.component.scss';

interface ConversationHistoryProps {
  toggleRef?: React.RefObject<HTMLElement>;
}

export const ConversationHistory: React.FC<ConversationHistoryProps> = ({ toggleRef }) => {
  const { state, actions } = useResearchContext();
  const { showConversationHistory, historyLoading, conversationHistory } = state;
  const containerRef = useRef<HTMLDivElement | null>(null);

  useOutsideClick(containerRef as React.RefObject<HTMLElement>, () => {
    if (actions.setMultiple) actions.setMultiple({ showConversationHistory: false });
  }, { includeEscape: true, excludes: toggleRef ? [toggleRef] : [] });

  const handleLoad = (timestamp: number | string) => {
    // normalize to number when possible (existing state.timestamp is a number)
    const tsNumber = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;
    if (actions.setMultiple) actions.setMultiple({ timestamp: tsNumber as any, showConversationHistory: false });
    if (actions.loadChat) actions.loadChat(undefined as any, tsNumber as any);
  };

  const handleDelete = (timestamp: number | string) => {
    if (actions.deleteConversation) actions.deleteConversation(timestamp as any);
  };

  if (!showConversationHistory) return null;

  return (
    <div className="conversation-history-popup" ref={containerRef}>
      <div className='conversation-history-popup-box'>
        {historyLoading ? (
          <div className="conversation-history-loading">
            <CircleLoader isActive={true} size="small" />
            <div className="conversation-history-loading__label">Loading history...</div>
          </div>
        ) : (
          conversationHistory
            .filter(({ chat = [] }: any) => (chat || []).length > 0)
            .map(({ timestamp, chat = [], updatedAt }: any, index: number) => (
              <div key={`${String(timestamp)}-${String(updatedAt)}-${index}`} className="conversation-history-item">
                <div
                  id={String(timestamp)}
                  className="conversation-history"
                  onClick={() => handleLoad(timestamp)}
                  title={chat[0]?.content}
                >
                  {chat[0]?.content?.slice(0, 43) + `${chat[0]?.content?.length > 43 ? "..." : ""}  `}
                </div>
                <div className="history__date"> {getRelativeTimeFromEpoch(updatedAt)}</div>
                <i
                  id={String(timestamp)}
                  className="material-icons history__delete"
                  onClick={() => handleDelete(timestamp)}
                >
                  delete
                </i>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default ConversationHistory;
